import React from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { InputLabel, MenuItem, Select } from '@material-ui/core'

import { USER_PERMISSION, translatePermission } from 'utils/constants/user'
import { ORGANIZATION_MASTER } from 'utils/constants/organizationMaster'
import { isPermissionMaster } from 'utils/validators'

import styles from './styles'

export default ({
  value,
  orgName,
  onChange,
  hasError = false,
}) => {
  const classes = styles()

  const userPermission = useSelector((state) => state.user.permission)

  const renderMenuItems = () => {
    const common = USER_PERMISSION.COMMON
    const admin = USER_PERMISSION.ADMIN
    const master = USER_PERMISSION.MASTER

    const items = [
      <MenuItem key={common} value={common}>{translatePermission(common)}</MenuItem>,
      <MenuItem key={admin} value={admin}>{translatePermission(admin)}</MenuItem>,
    ]

    if (isPermissionMaster(userPermission) && _.values(ORGANIZATION_MASTER).includes(orgName)) {
      items.push(<MenuItem key={master} value={master}>{translatePermission(master)}</MenuItem>)
    }

    return items
  }

  const renderPermissionSelect = () => {
    return (
      <div className={classes.container}>
        <InputLabel>Permissão</InputLabel>
        <Select
          name="permission"
          value={value}
          onChange={onChange}
          error={hasError}
        >
          {renderMenuItems()}
        </Select>
      </div>
    )
  }

  return renderPermissionSelect()
}
